export default __webpack_public_path__ + "static/media/Nimish.159da035.png";